import { render } from "./onePerformer.vue?vue&type=template&id=696e353d"
const script = {}

import "./onePerformer.vue?vue&type=style&index=0&id=696e353d&lang=css"

import exportComponent from "/var/www/turkey-2026/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__